module.exports = __webpack_public_path__ + "img/afarsek_no.763630f8.png";